import Header from "../../../../Components/Header";
import AssemblyForm from "./AssemblyForm";


const DraftAssembly = () => {
  return (
    <div className='d-flex flex-column' style={{minHeight:'100vh'}}>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
        <AssemblyForm />
      </div>
    </div>
  );
};

export default DraftAssembly;
